export default "__VITE_ASSET__3tSz8zY7__"